import * as React from "react";
const SvgFiRrCursorFinger = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cursor-finger_svg__a)">
      <path
        fill="#062147"
        d="M17.98 9.376 12 8.18V3.107A3.08 3.08 0 0 0 9.5.041 3 3 0 0 0 6 3v6.661L3.211 13.3a5.02 5.02 0 0 0 .25 6.794l2.4 2.425A5.04 5.04 0 0 0 9.413 24H17a5.006 5.006 0 0 0 5-5v-4.721a5.01 5.01 0 0 0-4.02-4.903M20 19a3 3 0 0 1-3 3H9.414a3.02 3.02 0 0 1-2.134-.891l-2.4-2.428a3.03 3.03 0 0 1-.116-4.123L6 12.945V17a1 1 0 1 0 2 0V3a1 1 0 0 1 1.176-.985 1.08 1.08 0 0 1 .825 1.092V9a1 1 0 0 0 .8.98l6.783 1.357A3.01 3.01 0 0 1 20 14.279z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cursor-finger_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCursorFinger;
